import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';
import ListCellText from 'src/components/atoms/list/ListCellText';
import { firestore } from 'firebase';
import dayjs from 'dayjs';

interface Props {
  order_number: string;
  created_at: firestore.Timestamp;
  amount: number;
  quantity: number;
}

export const OrderList = ({ ...props }: Props) => {
  const formatDate = (date: firestore.Timestamp) => {
    return dayjs(date.toDate()).format('HH:mm');
  };

  return (
    <Styled>
      <div className="inner">
        <div className="left">
          <p className="hdg">
            受取番号：<span>{props.order_number}</span>
          </p>
          <div className="detail">
            <ListCellText dt={'注文時刻'} dd={formatDate(props.created_at)} />
            <ListCellText dt={'売上価格'} dd={`${props.amount}円（税込）`} />
          </div>
        </div>
        <div className="right">
          <p className="count">
            注文個数：<span>{props.quantity}個</span>
          </p>
        </div>
      </div>
    </Styled>
  );
};

const Styled = styled.div`
  background-color: #fff;
  box-sizing: border-box;
  > .inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${StyleConfig.HELPER.M16};
    .hdg {
      font-size: 16px;
      font-weight: bold;
      color: ${StyleConfig.COLOR.PRIMARY};
    }
    .count {
      font-size: 16px;
      font-weight: bold;
    }
    .left {
      width: 60%;
    }
  }
`;
export default OrderList;
